module.exports = __webpack_public_path__ + "img/download.570eb1eb.svg";